<template>
  <div>
    <slot name="operateItem"></slot>
    <div class="search_box">
      <Form :label-width="lableWidth" v-show="searchVisible" @submit.native.prevent size="small">
        <slot name="formItem"></slot>
        <div class="search_btn" v-if="!localFilter || !localFilter.key">
          <Button class="btn_common btn_common_primary" type="primary" @click="onSearchClick">搜索</Button>
          <Button class="btn_common btn_common_default" @click="onEmptyClick">清空</Button>
        </div>
      </Form>
    </div>
    <div class="page_content">
      <slot name="tabs"></slot>
      <div class="table_wrap" v-if="typeCom==='table'">
        <Table :draggable="draggable" @on-drag-drop="onDraggable" class="common_table" ref="tablePage" :data="(localFilter && localFilter.key) ? insideTableData.filter(a => a[localFilter.key].indexOf([localFilter.value]) > -1) : insideTableData" :columns="insideColumns" :stripe="stripe" :border="border" :show-header="showHeader" :width="width" :height="height" :loading="loading" :disabled-hover="disabledHover" :highlight-row="highlightRow" :row-class-name="rowClassName" :size="size" :no-data-text="noDataText" :no-filtered-data-text="noFilteredDataText" @on-current-change="onCurrentChange" @on-select="onSelect" @on-select-cancel="onSelectCancel" @on-select-all="onSelectAll" @on-selection-change="onSelectionChange" @on-sort-change="onSortChange" @on-filter-change="onFilterChange" @on-row-click="onRowClick" @on-row-dblclick="onRowDblclick" @on-expand="onExpand">
          <slot name="header" slot="header"></slot>
          <slot name="footer" slot="footer"></slot>
          <slot name="loading" slot="loading"></slot>
        </Table>
      </div>
      <photo-wall v-if="typeCom==='photo'" ref="tablePage" :photos="insideTableData" :height="height" @delete="onDelete" :loading="loading"/>
      <slot name="bottom"></slot>
      <div class="pagination" v-if="showPager">
        <Page :total="total" :current.sync="currentPage" :page-size="limit" :page-size-opts="limitOpts" show-total show-elevator show-sizer @on-change="handlePageChange" @on-page-size-change="handleSizeChange"></Page>
      </div>
    </div>
  </div>
</template>
<script>
import PhotoWall from './photo-wall.vue'
import apiClient from '@/api/pagelist'
export default {
  name: 'TablePage',
  components: {
    PhotoWall
  },
  model: {
    prop: 'dataSource',
    event: 'change'
  },
  props: {
    searchVisible: {
      type: Boolean,
      default: true
    },
    draggable: {
      type: Boolean,
      default: false
    },
    dataSource: {
      type: Array,
      default () {
        return []
      }
    },
    columns: {
      type: Array,
      default () {
        return []
      }
    },
    url: {
      type: String,
      default: ''
    },
    param: {
      type: Object,
      default: () => { return {} }
    },
    size: String,
    width: {
      type: [Number, String]
    },
    // height: {
    //   type: [Number, String]
    // },
    nodeKey: {
      type: String,
      default: ''
    },
    selecteds: {
      type: Array,
      default: () => ([])
    },
    stripe: {
      type: Boolean,
      default: false
    },
    border: {
      type: Boolean,
      default: false
    },
    showHeader: {
      type: Boolean,
      default: true
    },
    highlightRow: {
      type: Boolean,
      default: false
    },
    rowClassName: {
      type: Function,
      default () {
        return ''
      }
    },
    context: {
      type: Object
    },
    noDataText: {
      type: String
    },
    noFilteredDataText: {
      type: String
    },
    disabledHover: {
      type: Boolean
    },
    /**
     * @description 全局设置是否可编辑
     */
    editable: {
      type: Boolean,
      default: true
    },
    localFilter: {
      type: Object,
      default: () => {}
    },
    showPager: {
      type: Boolean,
      default: true
    },
    autoLoad: {
      type: Boolean,
      default: true
    },
    additionalObj: {
      type: Object,
      default: () => { return {} }
    },
    noClearParam: {
      type: Array,
      default: () => []
    },
    lableWidth: {
      type: [Number, String],
      default: 80
    },
    typeCom: {
      type: String,
      default: 'table' // photo
    },
    onDelete: {
      type: Function,
      default: row => {}
    },
    onDraggable: {
      type: Function,
      default: () => {}
    },
    onsortTable: {
      type: Function,
      default: () => {}
    }
  },
  data () {
    return {
      loading: true,
      height: 100,
      insideColumns: [
        {title: '序号', key: 'index', width: 80, fixed: 'left'}
      ],
      insideTableData: [],
      total: 0,
      currentPage: 1,
      limit: 10,
      limitOpts: [10, 20, 50, 100]
    }
  },
  watch: {
    // columns (columns) {
    //   this.handleColumns(columns)
    // },
    insideTableData (val) {
      // this.$emit('change', this.insideTableData)
      this.$emit('update:dataSource', val)
    },
    value (val) {
      this.handleTableData(val)
    },
    param: {
      handler (val, oldVal) {
        if (this.currentPage !== 1) {
          this._changeCurrentPage = true
        }
      },
      deep: true
    }
  },
  mounted () {
    this.setTableHeight()
    if (this.typeCom === 'table') this.handleColumns(this.columns)
    if (this.url) {
      if (this.url === 'getOrderList') {
        this.$nextTick(() => {
          if (this.autoLoad) {
            this.getTableDate()
          }
        })
      } else {
        this.$nextTick(() => {
          if (this.autoLoad) {
            this.getTableDate()
          }
        })
      }
    } else {
      this.handleTableData(this.dataSource)
    }
  },
  methods: {
    setTableHeight () {
      this.$nextTick(function () {
        let contentWrap = document.getElementsByClassName('content_wrap')[0].offsetHeight
        let topOperate = 0
        let tabsBar = 0
        if (document.getElementsByClassName('top_operate')[0]) {
          topOperate = document.getElementsByClassName('top_operate')[0].offsetHeight
        }
        if (document.getElementsByClassName('ivu-tabs-bar')[0]) {
          tabsBar = 70
        }
        let searchBox = document.getElementsByClassName('search_box')[0].offsetHeight
        let tableHeight = contentWrap - topOperate - tabsBar - searchBox - 100
        if (this.$parent.$el.getElementsByClassName('ivu-modal-body')[0]) {
          tableHeight = 400
        }
        this.height = tableHeight
      })
    },
    selectAll (statsu) {
      this.$refs.tablePage.selectAll(statsu)
    },
    onSearchClick () {
      this.refreshData()
    },
    onEmptyClick () {
      let dic = JSON.parse(JSON.stringify(this.param))
      for (let key in dic) {
        if (this.noClearParam.includes(key)) {
          continue
        }
        if (dic[key] === undefined || dic[key] === null) {
          continue
        }
        if (dic[key].constructor === String) {
          dic[key] = ''
        } else if (dic[key].constructor === Array) {
          dic[key] = []
        } else {
          dic[key] = null
        }
      }
      this.$emit('update:param', dic)
    },
    // page
    handlePageChange (value) {
      this.getTableDate()
    },
    handleSizeChange (value) {
      this.limit = value
      this.getTableDate()
    },
    // 父组件搜索
    refreshData (flag = 'isUpdate') {
      if (flag === 'isAdd') {
        this.currentPage = 1
        this.onEmptyClick()
      }
      this.getTableDate()
    },
    afterDetele () {
      if (this.insideTableData.length > 1) {
        this.getTableDate()
      } else {
        if (this.currentPage > 1) {
          this.currentPage -= 1
          this.getTableDate()
        } else {
          this.refreshData()
        }
      }
    },
    // 获取数据
    getTableDate () {
      if (!this.url) {
        return
      }
      if (!this.loading) {
        this.loading = true
      }
      let req = {}
      if (this._changeCurrentPage) {
        this.currentPage = 1
        this._changeCurrentPage = false
      }
      let limit = {
        page: this.currentPage,
        limit: this.limit
      }
      let param = JSON.parse(JSON.stringify(this.param))
      for (let key in param) {
        /** 搜索条件对象中不需要传递给后台的字段用'searchDate'开头， 如时间，一些数组等 */
        if (key.indexOf('searchDate') > -1) {
          delete param[key]
        }
        // 如果值为空就不传
        if (!param[key]) {
          delete param[key]
        }
      }
      Object.assign(req, param, limit)
      if (!apiClient[this.url]) { return this.$common.errorTip('方法出错了') }
      apiClient[this.url](req).then(res => {
        this.loading = false
        this.limit = res.data.limit || limit.limit
        this.currentPage = res.data.page || limit.page
        this.total = res.data.count
        if (this.url === 'getEditionList') {
          res.data.list = res.data.list || []
          let version = res.data.list.find(d => d.versionId === res.data.currentVersion.versionId)
          if (version) {
            version.useFlag = 'YES'
          }
        }
        if (this.url === 'getGoodsList') {
          res.data.list = res.data.list.map(v => {
            v.pageUrl = '/pages/goodsdetail/goodsdetail?goodsId=' + v.goodsId
            return v
          })
        }
        this.insideTableData = this.indexHandle(JSON.parse(JSON.stringify(res.data.list || res.data)))
        if (this.url === 'getCaseList') {
          this.insideTableData = this.insideTableData.map(v => {
            v.caseCatIdName = v.caseCatIdName.split(',').filter(v => v).join(',')
            return v
          })
        }
        if (Object.keys(this.additionalObj).length > 0) {
          for (const key in this.additionalObj) {
            this.additionalObj[key] = res.data[key]
          }
          console.log(this.additionalObj)
          this.$emit('update:additionalObj', this.additionalObj)
        }
      }).catch(e => {
        this.$common.errorTip(e.message)
      })
    },
    handleColumns (columns) {
      if (columns[0].type === 'selection') {
        if (columns[0].fixed) {
          columns.splice(1, 0, {title: '序号', key: 'index', width: 80, sortable: false, fixed: 'left'})
          this.insideColumns = columns
        } else {
          columns.splice(1, 0, {title: '序号', key: 'index', width: 80, sortable: false})
          this.insideColumns = columns
        }
      } else if (columns[0].key !== 'index') {
        this.insideColumns = this.insideColumns.concat(columns)
      } else {
        this.insideColumns = columns
      }
      this.insideColumns = this.insideColumns.map((item, index) => {
        let res = item
        return res
      })
    },
    handleTableData (array) {
      this.insideTableData = this.indexHandle(array)
    },
    exportCsv (params) {
      this.$refs.tablesMain.exportCsv(params)
    },
    clearCurrentRow () {
      this.$refs.talbesMain.clearCurrentRow()
    },
    onCurrentChange (currentRow, oldCurrentRow) {
      this.$emit('on-current-change', currentRow, oldCurrentRow)
    },
    onSelect (selection, row) {
      this.$emit('on-select', selection, row)
    },
    onSelectCancel (selection, row) {
      this.$emit('on-select-cancel', selection, row)
    },
    onSelectAll (selection) {
      this.$emit('on-select-all', selection)
    },
    onSelectionChange (selection) {
      this.$emit('on-selection-change', selection)
    },
    onSortChange (column, key, order) {
      this.$emit('on-sort-change', column, key, order)
    },
    onFilterChange (row) {
      this.$emit('on-filter-change', row)
    },
    onRowClick (row, index) {
      this.$emit('on-row-click', row, index)
    },
    onRowDblclick (row, index) {
      this.$emit('on-row-dblclick', row, index)
    },
    onExpand (row, status) {
      this.$emit('on-expand', row, status)
    },
    // util
    indexHandle (array, page = this.currentPage, limit = this.limit) {
      // console.log(this.selecteds)
      // console.log(this.nodeKey)
      array.map((obj, index) => {
        obj['index'] = index + (page - 1) * limit + 1
        if (this.selecteds.length > 0 && this.nodeKey) {
          obj['_checked'] = this.selecteds.includes(obj[this.nodeKey])
        }
      })
      return array
    }
  }
}
</script>
<style scoped>
.page_content{
  position: relative;
}
.table_pagination{
  position: fixed;
  right: 60px;
  bottom: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/table-page.vue